import { render, staticRenderFns } from "./PlacementBadge.vue?vue&type=template&id=29236934&scoped=true"
import script from "./PlacementBadge.vue?vue&type=script&lang=js"
export * from "./PlacementBadge.vue?vue&type=script&lang=js"
import style0 from "./PlacementBadge.vue?vue&type=style&index=0&id=29236934&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29236934",
  null
  
)

export default component.exports